import template from './documents.page.html';
import signatureBlock from './signature-block/page.signature-block.js';
import columnsBlock from './columns-block/page.columns-block.js';
import form from './form/page.form.js';
import greyList from './grey-list/page.grey-list.js';

export default angular
  .module('doxy.realtime.components.teleconsent.action.document.page', [
    signatureBlock,
    columnsBlock,
    form,
    greyList,
  ])
  .component('documentPage', {
    //document-page
    template,
    bindings: {
      page: '<',
      fields: '<',
      data: '<',
      me: '<',
    },
    controller: function () {
      this.isFieldDisabled = (field) => {
        return !this.me || field.editBy !== this.me.type;
      };
    },
  }).name;
